import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const Footer=()=> {
  const [cookieIsAccepted,setCookieIsAccepted]=useState(true)
  const [ageIsAccepted,setAgeIsAccepted]=useState(true)

  useEffect(()=>{
const value=localStorage.getItem("cookie")
const ageValue=localStorage.getItem("age")
if(value)
{
  setCookieIsAccepted(false)
}
if(ageValue)
  {
    setAgeIsAccepted(false)
  }
  },[])

const acceptCookie=()=>{
  setCookieIsAccepted(false)
  localStorage.setItem("cookie",true)
}
const acceptAge=()=>{
  setAgeIsAccepted(false)
  localStorage.setItem("age",true)
}

  return (
    <>
<footer>
    <div className="disclaimer">
        <p>
            <strong>Αποποίηση ευθύνης (Disclaimer):</strong><br />
            Αυτός ο ιστότοπος προσφέρει μόνο κοινωνικά παιχνίδια καζίνο για διασκέδαση. Τα παιχνίδια δεν επιτρέπουν τη χρήση πραγματικών χρημάτων ούτε παρέχουν τη δυνατότητα κέρδους πραγματικών χρημάτων.<br />
            <br />
            <strong>Όριο ηλικίας:</strong><br />
            Η πρόσβαση σε αυτόν τον ιστότοπο και το περιεχόμενό του επιτρέπεται μόνο σε άτομα άνω των 18 ετών. Μην χρησιμοποιείτε αυτόν τον ιστότοπο εάν δεν πληροίτε την ηλικιακή απαίτηση.<br />
            <br />
            <strong>Προειδοποίηση για εθισμό στα τυχερά παιχνίδια:</strong><br />
            Θυμηθείτε ότι τα παιχνίδια προορίζονται αποκλειστικά για διασκέδαση. Παίξτε υπεύθυνα και διατηρήστε τον έλεγχο των συνηθειών σας. Για βοήθεια σχετικά με τον εθισμό στα τυχερά παιχνίδια, επισκεφθείτε 
            <a href="https://www.gamblingtherapy.org/" target="_blank" rel="noopener noreferrer">αυτήν τη σελίδα</a>.<br />
            <br />
            <strong>Νομική συμμόρφωση:</strong><br />
            Αυτός ο ιστότοπος λειτουργεί σύμφωνα με τους ισχύοντες νόμους και κανονισμούς. Οι χρήστες είναι υπεύθυνοι για τη συμμόρφωση με τους νόμους της δικής τους περιοχής.
        </p>
    </div>

    <div className="bottom-row mt-3 mb-3">
        <div className="container d-flex align-items-center justify-content-between">
            <div className="logo-wrapper d-flex align-items-center justify-content-between">
                <a href="/">
                    <img src="/logo.png" alt="logo"/>
                </a>
                <a href="/" className="main-logo-text">
                    <p className="game-name">
                        Crazy Monkey Slot
                    </p>
                    <span>
                        Το Δωρεάν Κοινωνικό Καζίνο σας
                    </span>
                </a>
            </div>
            <div className="navigation">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="7.5" width="16" height="1.5"></rect><rect x="4" y="15" width="16" height="1.5"></rect></svg>
                <ul className="nav-list d-flex align-items-center justify-content-center">
                    <li>
                        <a href="/">
                            Αρχική σελίδα
                        </a>
                    </li>
                    <li>
                        <a href="contact-us">
                            Επικοινωνία
                        </a>
                    </li>
                    <li>
                        <a href="privacy-policy">
                            Πολιτική απορρήτου
                        </a>
                    </li>
                    <li>
                        <a href="terms-and-conditions">
                            Όροι και προϋποθέσεις
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>

{
    cookieIsAccepted &&(
      <div className="cookie-banner" id="cookie-banner" style={{display:'flex'}}>
      <p>Χρησιμοποιούμε cookies για να βελτιώσουμε την απόδοση του ιστότοπού μας. Συνεχίζοντας την περιήγηση, αποδέχεστε τη χρήση των cookies.</p>
      <button  onClick={()=>acceptCookie()}  id="accept-cookies">Αποδοχή</button>
  </div>
    )
}
{
    ageIsAccepted &&(
      <div className="age-check-popup" id="age-check-popup">
        <div className="popup-inner-wrapper">
            <h3 className="text-center">
                Επιβεβαίωση ηλικίας
            </h3>
            <p className="popup-text text-center">
                Πρέπει να είστε τουλάχιστον <span>18</span> ετών για να συμμετάσχετε.
            </p>
            <button type="button" onClick={()=>acceptAge()} className="text-center popup-btn">
                Ναι
            </button>
        </div>
    </div>
    )
}

    </>

  );
}

export default Footer;